var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.power > 0)?_c('v-progress-linear',{attrs:{"color":"orange","height":"15","rounded":""},model:{value:(_vm.power),callback:function ($$v) {_vm.power=$$v},expression:"power"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }